const ProjectListing = () => import('@/components/partner/project/Listing')
const ProjectCreate = () => import('@/components/partner/project/Create')
const ProjectEdit = () => import('@/components/partner/project/Edit')
const PartnerContributionListing = () => import('@/components/partner/contributions/Listing')
const PartnerProfile = () => import('@/components/partner/profile/Form')
const Resources = () => import('@/components/partner/Resources')
const PartnerContributionManagement = () => import('@/components/partner/Contribution')

const PartnerUpdates = () => import('@/components/partner/updates/Listing')
const ProjectUpdates = () => import('@/components/partner/updates/ProjectUpdates')
const ProjectUpdateDetails = () => import('@/components/partner/updates/ProjectUpdateDetails')

export default [
  {
    path: '/updates',
    name: 'updates',
    components: {
      partner: PartnerUpdates
    }
  },
  {
    path: '/profile',
    name: 'profile',
    components: {
      partner: PartnerProfile
    }
  },
  {
    path: '/project-updates-list/',
    name: 'project-updates-list',
    components: {
      partner: ProjectUpdates
    }
  },
  {
    path: '/project-update/:id',
    name: 'project-update',
    components: {
      partner: ProjectUpdateDetails
    }
  },
  {
    path: '/contributions',
    name: 'contributions',
    components: {
      partner: PartnerContributionListing
    }
  },
  {
    path: '/contributions-management',
    name: 'contributions-management',
    components: {
      partner: PartnerContributionManagement
    }
  },
  {
    path: '/resources',
    name: 'resources',
    components: {
      partner: Resources
    }
  },
  {
    path: '/projects/create',
    name: 'projects.create',
    components: {
      partner: ProjectCreate
    }
  },
  {
    path: '/projects/edit/:id',
    name: 'projects.edit',
    components: {
      partner: ProjectEdit
    }
  },
  {
    path: '/projects-list',
    name: 'projects',
    components: {
      partner: ProjectListing
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/partner.js